/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const TransactionValueFormatter = (cellContent, row, rowIndex) => {
  const { id } = row;
  return (
    <>
      <div className="d-flex align-items-center">{id ? id : "-"}</div>
      <> </>
    </>
  );
};
